module.exports = __webpack_public_path__ + "img/logo.0004a284.png";